<template>
  <Main>
    <v-container>
      <v-row justify="center">
        <v-col cols="12">
          <v-card class="pa-5">
            <v-row dense>
              <v-col cols="12">
                <strong>Overview Calendar</strong>
              </v-col>
            </v-row>
            <hr />
            <v-row class="mt-4">
          
              <v-col cols="3" md="3">
                <v-autocomplete
                  @change="filterDataTable"
                  v-model="year"
                  :items="yearList"
                  item-text="YEAR"
                  label="Year"
                  color="red darken-1"
                  outlined
                  dense
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-card class="pa-3" outlined>
                  <v-card-title>
                    <v-btn
                      class="ml-2"
                      @click="downloadCSV()"
                      outlined
                      color="indigo lighten-1"
                      :disabled="dtLoading"
                      >Export Data</v-btn
                    >
                    <!-- <v-spacer></v-spacer>
                    <v-text-field
                      color="red darken-1"
                      v-model="searchRole"
                      append-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                    ></v-text-field> -->
                  </v-card-title>
                  <v-data-table
                    :headers="dtHeaders"
                    :items="dtItems"
                    :loading="dtLoading"
                    loading-text="Fetching Data..."
                    dense
                  >
                    <template v-slot:item.edit="{ item }">
                      <v-icon small class="mr-2" @click="editItem(item.ROLE_MAP_ID)"
                        >mdi-pencil</v-icon
                      >
                    </template>
                  </v-data-table>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <!-- SNACKBAR -->
    <v-snackbar v-model="isShowSnackbar" top>{{ snackbarText }}</v-snackbar>
    <!-- LOADING OVERLAY -->
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </Main>
</template>

<style>
thead.v-data-table-header > tr > th > div {
  display: inline-block;
  width: 90%;
}

thead.v-data-table-header > tr > th > div.v-input label {
  font-size: 12px;
}
</style>

<script>
import Main from "@/Main.vue";
import moment from "moment";
import XLSX from "xlsx";

const dtHeaders = [
  {
    text: "YEARID",
    align: "start",
    value: "YEARID",
  },
  {
    text: "MONTHID",
    value: "MONTHID",
  },
  {
    text: "WEEK",
    value: "WEEK",
  },
  {
    text: "DAY",
    value: "DAY",
  },
  {
    text: "IS DAYS OFF",
    value: "IS_DAYS_OFF",
  },
  {
    text: "DATE",
    value: "DATE",
  }
];

export default {
  components: {
    Main,
  },
  data() {
    return {
      isLoading: false,
      isShowSnackbar: false,
      snackbarText: "",
      branchList: [],
      periodeList: [],
      positionList: [],
      yearList: [],
      branch: "ALL BRANCH",
      position: "NONE",
      periode: "NONE",
      year: "NONE",
      searchRole: "",
      dtLoading: false,
      dtHeaders,
      dtItems: [],
      isSuperUser:
        JSON.parse(localStorage.getItem("userData")).ORG_ID == 81 ? true : false,
    };
  },
  mounted() {
     this.loadYear();
  },
  methods: {
    downloadCSV() {
      const workBook = XLSX.utils.book_new(); // create a new blank book
      const workSheet = XLSX.utils.json_to_sheet(this.dtItems);
      XLSX.utils.book_append_sheet(workBook, workSheet, "Sheet1"); // add the worksheet to the book
      XLSX.writeFile(workBook, "Overview Calendar.xlsx"); // initiate a file download in browser
    },
     loadYear() {
      this.isLoading = true;
      let orgID="";
      this.$http
        .post("/call-management/prepareFilterCalendar", { orgID: orgID }, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {
          this.isLoading = false;
          let { data } = res.data;
          this.yearList = data;
          this.filterDataTable();
        })
        .catch((err) => {
          this.isLoading = false;
          console.log(err.toString());
        });
    },
    filterDataTable() {
      this.dtLoading = true;
      const data = {
        year: this.year
      };
      console.log(data);
      this.$http
        .post("/call-management/overviewcalendar", data, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {
          let { data } = res.data;
          console.log('data calendar ', data);
          if (data == null) {
            this.dtLoading = false;
            this.dtItems = [];
          } else {
            this.dtLoading = false;
                        data.forEach((obj, index) => {
                          data[index].DATE = moment(
                            new Date(data[index].DATE)
                          ).format("MM/DD/YYYY");
                        });
            this.dtItems = data;
          }
        })
        .catch((err) => {
          this.dtLoading = false;
          this.showSnackbar(err.toString());
        });
    },
    editItem(roleMapId) {
      this.$router.push({
        path: `/manage-role/new/${roleMapId}`,
      });
    },
    showSnackbar(text) {
      this.snackbarText = text;
      this.isShowSnackbar = true;
    },
  },
};
</script>
